import { rankingData } from '@/mocks/homeData';

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          热议榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">本周最受关注的争议事件排行</p>
        <div className="flex flex-col gap-3">
          {rankingData.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              className="flex items-center gap-4 p-4 bg-background-100 border border-background-200 rounded-xl hover:border-accent-300 hover:bg-accent-50/30 transition-all cursor-pointer group"
            >
              <span className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-white' :
                item.rank === 2 ? 'bg-accent-400 text-white' :
                item.rank === 3 ? 'bg-accent-300 text-accent-800' :
                'bg-secondary-200 text-secondary-700'
              }`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-accent-700 transition-colors truncate">
                  {item.title}
                </h3>
              </div>
              <span className="text-xs text-foreground-500 bg-background-200 px-2.5 py-1 rounded-full whitespace-nowrap">
                {item.tag}
              </span>
              <span className="text-xs text-accent-600 font-medium whitespace-nowrap hidden sm:block">
                {item.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}